
<loader></loader>
<form>
  <input type="file" multiple (change)="onSelectFile($event)">
  <p>Arraste seus arquivos aqui ou clique nesta área.
    Obs: Ao inserir/Arrastar o arquivo, o mesmo sera carregado automaticamente!
  </p>

</form>
